import { Outlet } from 'react-router-dom'
import Header from './Header'

export default function Layout() {
  return (
    <div className="min-h-screen bg-dark-gradient relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Gradient orbs - teal/cyan theme */}
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary/15 rounded-full blur-3xl animate-pulse-slow" />
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-accent/15 rounded-full blur-3xl animate-pulse-slow" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />

        {/* Grid pattern overlay - teal tinted */}
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `
              linear-gradient(rgba(45, 212, 191, 0.4) 1px, transparent 1px),
              linear-gradient(90deg, rgba(45, 212, 191, 0.4) 1px, transparent 1px)
            `,
            backgroundSize: '50px 50px',
          }}
        />
      </div>

      {/* Header */}
      <Header />

      {/* Main content */}
      <main className="relative z-10 min-h-screen pt-16">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="relative z-10 py-6 text-center border-t border-surface-border/30">
        <p className="text-xs text-muted/60">
          &copy; {new Date().getFullYear()} RugScan. All rights reserved.
        </p>
      </footer>
    </div>
  )
}
